import {cmsLoadDynamicCopy, cmsLoadFlowCopy} from '@actions/cms.action';
import { inject } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import {
  CmsDynamicFlows,
  CmsDynamicKeys,
  CmsDynamicSubFlows, ContentPageKeys,
} from '@constants/cms.constants';
import { Store } from '@ngrx/store';
import { CoreState } from '@reducers/index';
import { selectIsCultureValidAndEnabled } from '@selectors/router.selector';
import { convertToUpperCamelCase } from '@utils/data-utils';
import { Observable, filter, map } from 'rxjs';

export const cmsDynamicDataGuard = (
  route: ActivatedRouteSnapshot,
): Observable<boolean> => {
  const store = inject<Store<CoreState>>(Store);

  return store.select(selectIsCultureValidAndEnabled).pipe(
    filter((isValid) => isValid),
    map(() => {
      const previousParts: string[] = [];
      route.url.forEach((urlPart) => {
        const cmsCopyName = convertToUpperCamelCase(urlPart.path);
        const flowKey = (previousParts[0] ?? cmsCopyName) as CmsDynamicFlows;
        const subFlowKey = previousParts[0]
          ? ((previousParts[1] ?? cmsCopyName) as CmsDynamicSubFlows)
          : undefined;
        const cmsKey = previousParts[1]
          ? ((previousParts[2] ?? cmsCopyName) as CmsDynamicKeys)
          : undefined;

        store.dispatch(cmsLoadDynamicCopy({ flowKey, subFlowKey, cmsKey }));
        previousParts.push(cmsCopyName);
      });

      route.data?.umbracoContentPages?.forEach((contentPageKey: ContentPageKeys) => {
        store.dispatch(
          cmsLoadFlowCopy({contentPageKey})
        )
      })

      return true;
    }),
  );
};
